/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import "actiontext"
import Sortable from 'sortablejs';
import Rails from "@rails/ujs";

document.addEventListener('turbolinks:load', () => {
  const initKanbanSortable = (ulElements) => {
    ulElements.forEach((ul) => {
      new Sortable(ul, {
          group: 'kanban', // set both lists to same group
          animation: 200,
          onEnd: function(event){ saveKanban(ulElements, event.item) },
          draggable: "li.kanban-col-item"
      });
    });
  };
  const saveKanban = (ulElements, targetItem) => {
    targetItem.classList.add("loading");
    const kanbanIds = {"columns": []};
    ulElements.forEach(ul => {
      const itemIds = [];
      ul.querySelectorAll(".kanban-col-item")
        .forEach(item => itemIds.push(Number.parseInt(item.dataset.itemId,10)));
      kanbanIds.columns.push(
        {
          'id': ul.dataset.colId,
          'itemIds': itemIds
        }
      );
    });
    kanbanIds['targetItemId'] = targetItem.dataset.itemId
    //kanbanForm.value = JSON.stringify(kanbanIds);
    const formData = new FormData();
    const companySlug = document.querySelector(".kanban").dataset.companySlug;
    formData.append('kanban[kanbanIds]', JSON.stringify(kanbanIds));
    Rails.ajax({
      url: `/companies/${companySlug}/update_kanban`,
      type: "patch",
      data: formData,
      success: function(){targetItem.classList.remove("loading");}
    })
  }
  const kanbanUls = document.querySelectorAll(".kanban .kanban-col");
  if (kanbanUls) {
    initKanbanSortable(kanbanUls);
  }
});
require("trix")
require("@rails/actiontext")